<template>
  <div class="space-y-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- Job Title -->
      <div class="space-y-2">
        <label class="text-[14px] font-bold text-foreground">Title*</label>
        <input
          :value="item.title"
          @input="update('title', $event.target.value)"
          type="text"
          placeholder="It is important for products..."
          class="w-full px-5 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 transition-all"
          required
        />
      </div>

      <!-- Start Date -->
      <div class="space-y-2">
        <label class="text-[14px] font-bold text-foreground">Start date*</label>
        <div class="grid grid-cols-2 gap-3">
          <select
            :value="item.startMonth"
            @change="update('startMonth', $event.target.value)"
            class="w-full px-4 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-muted-foreground outline-none focus:ring-1 focus:ring-primary/20 appearance-none bg-[url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M5%207.5L10%2012.5L15%207.5%22%20stroke%3D%22%23666%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22/%3E%3C/svg%3E')] bg-[length:20px_20px] bg-[right_16px_center] bg-no-repeat"
          >
            <option value="" disabled>Month</option>
            <option v-for="m in months" :key="m" :value="m">{{ m }}</option>
          </select>
          <input
            :value="item.startYear"
            @input="update('startYear', $event.target.value)"
            type="text"
            placeholder="Year"
            class="w-full px-5 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 transition-all"
          />
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- Company (Reusing title slot for simplicity in demo, but should have its own label) -->
      <div class="space-y-2">
        <label class="text-[14px] font-bold text-foreground">Company*</label>
        <input
          :value="item.organization"
          @input="update('organization', $event.target.value)"
          type="text"
          placeholder="Edgespace"
          class="w-full px-5 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 transition-all"
        />
      </div>

      <!-- End Date -->
      <div class="space-y-2">
        <label class="text-[14px] font-bold text-foreground">End date*</label>
        <div class="grid grid-cols-2 gap-3">
          <select
            :value="item.endMonth"
            @change="update('endMonth', $event.target.value)"
            class="w-full px-4 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-muted-foreground outline-none focus:ring-1 focus:ring-primary/20 appearance-none bg-[url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M5%207.5L10%2012.5L15%207.5%22%20stroke%3D%22%23666%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22/%3E%3C/svg%3E')] bg-[length:20px_20px] bg-[right_16px_center] bg-no-repeat"
          >
            <option value="" disabled>Month</option>
            <option v-for="m in months" :key="m" :value="m">{{ m }}</option>
          </select>
          <input
            :value="item.endYear"
            @input="update('endYear', $event.target.value)"
            type="text"
            placeholder="Year"
            class="w-full px-5 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 transition-all"
          />
        </div>
      </div>
    </div>

    <!-- Description -->
    <div class="space-y-2">
      <div class="flex justify-between items-center px-1">
        <label class="text-[14px] font-bold text-foreground"
          >Description*</label
        >
        <span class="text-xs text-muted-foreground font-medium">
          {{ item.description ? item.description.length : 0 }}/10000
        </span>
      </div>
      <div class="relative group">
        <textarea
          :value="item.description"
          @input="update('description', $event.target.value)"
          maxlength="10000"
          placeholder="It is important for products..."
          class="block w-full h-[200px] px-6 py-5 rounded-2xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 transition-all resize-none leading-relaxed text-[15px]"
        ></textarea>
        <!-- Resize icon -->
        <svg
          class="absolute bottom-4 right-4 w-4 h-4 text-muted-foreground/30"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 15L15 21M21 8L8 21"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExperienceForm",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  methods: {
    update(key, value) {
      this.$emit("update", { [key]: value });
    },
  },
};
</script>
